



















































































import {Component, Mixins} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import PageContentTop from '@/components/board/common/PageTopContent.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import FaqTopTable from '@/components/board/faq/FaqTopTable.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import PageDateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';

import ItemTable from '@/components/common/ItemTable.vue';
import {FaqQueryParameters, GridFormatterData} from '@/types';
import {centerWinOptions} from '@/utils/commonUtils';
import {ManageFaqCategory, ManageSearchType} from 'supporter';
import BoardMixin from '@/components/board/mixins/BoardMixin';

import {momentAdd} from '@/utils/dateUtils';

@Component({
  components: {
    PageTitle,
    PageContentTop,
    FaqTopTable,
    PageFormBtn,
    PageFormSelect,
    PageDateRangePicker,
    PageDateFilterBtns,
    ItemTable
  }
})
export default class FaqList extends Mixins(BoardMixin) {
  private contentBottomOption = {
    haveRigthBtn: false,
    onLoadSearch: false
  };
  private gridProps = {
    columns: [
      {
        header: this.toI18n('BOARD_FAQ_POST_NUMBER'), // 게시글 번호
        name: 'faqNo',
        align: 'center',
        minWidth: 25
      },
      {
        header: this.toI18n('BOARD_FAQ_FAQ_CATEGORY'), // FAQ 카테고리
        name: 'faqCategory',
        align: 'left',
        minWidth: 50,
        formatter: (data: GridFormatterData) => {
          return this.getFaqCategory(data.value);
        },
        copyOptions: {
          useFormattedValue: true
        }
      },
      {
        header: this.toI18n('BOARD_FAQ_TITLE'), // 제목
        name: 'faqTitle',
        align: 'left',
        minWidth: 800,
        formatter: function(data: GridFormatterData) {
          const url = '/board/popup/faq/' + data.row.faqNo;
          return `<a href="javascript:onClick=window.open ('${url}','newwindow','${centerWinOptions(888, 610)}')">${data.value}</a>`;
        },
        copyOptions: {
          customValue: (value): string => {
            return value;
          }
        }
      },
      {
        header: this.toI18n('BOARD_FAQ_CREATION_DATE'), // 작성일시
        name: 'createdDateTime',
        align: 'center',
        minWidth: 120
      }
    ],
    header: {
      height: 33
    },
    options: {
      rowHeaders: ['rowNum'],
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      minRowHeight: 31,
      rowHeight: 31,
      minBodyHeight: 190,
      bodyHeight: 190,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        visiblePages: 5,
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    }
  };

  private faqQueryParameters: FaqQueryParameters = {
    params: {
      faqCategory: '' as ManageFaqCategory,
      searchType: '' as ManageSearchType,
      keyword: '',
      startDateTime: '',
      endDateTime: '',
      pageSize: 30,
      page: 1,
      faqTargets: 'PLATFORM_TO_SERVICE'
    }
  };

  private faqData = null as any;
  private totalCount: number = 0;
  private search(page: number = 1): void {
    Object.assign(this.faqQueryParameters.params, {page, startDateTime: this.dateReceiveData.startYmd + ' 00:00:00', endDateTime: this.dateReceiveData.endYmd + ' 23:59:59'});
    if (this.faqQueryParameters.params.searchType !== 'ALL' && this.faqQueryParameters.params.keyword.length === 0) {
      alert(window.$t('BOARD_MIXINS_PLEASE_INPUT'));
      (this.$refs.keyword as any).focus();
    } else {
      this.$api
        .getFaqsPublic(this.faqQueryParameters)
        .then((respones: any) => {
          const data = respones.data;
          this.faqData = data.contents;
          this.totalCount = data.totalCount;
          this.gridProps.options.pageOptions.page = page;
          this.gridProps.options.pageOptions.totalCount = data.totalCount;
        })
        .catch(this.exceptionHandler);
    }
  }
  private reset(): void {
    Object.assign(this.faqQueryParameters.params, {
      faqCategory: this.faqCategoryData[0].value as ManageFaqCategory,
      searchType: this.searchTypeData[0].value as ManageSearchType,
      keyword: '',
      pageSize: 30,
      page: 1
    });

    this.dateFilterChange(3);
    Object.assign(this.dateData, {
      startYmd: momentAdd(this.today, this.filterDateMapping[this.currentDateRange], 'YYYY-MM-DD'),
      endYmd: this.today
    });

  }

  private created(): void {
    this.reset();
    this.search();
  }
}
